module.exports = __webpack_public_path__ + "static/media/card-btn.62034e05.png";